import { AnalyticsEvent, AnalyticsEventCategories } from '@/utils/analyticsEvents/categories';

export class CapacityCurveHeightResizedEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.CAPACITY_CURVE_HEIGHT_RESIZED;

  public constructor() {
    super();
  }
}

export class CapacityCurveViewChangedEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.CAPACITY_CURVE_VIEW_CHANGED;

  public constructor(
    public properties: {
      view: 'concurrent_orders' | 'persons';
    },
  ) {
    super();
  }
}

export class ScheduleViewSettingChangedCapacityCurveVisibilityEvent extends AnalyticsEvent {
  public readonly identification =
    AnalyticsEventCategories.SCHEDULE_VIEW_SETTING_CHANGED_CAPACITY_CURVE_VISIBILITY;

  public constructor(
    public properties: {
      show: boolean;
      method: 'shortcut' | 'sidebar' | 'row';
    },
  ) {
    super();
  }
}
